import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// SERVICES
import { AuthGuard } from './guards/auth.guard';
import { ConfirmService } from './services/app-confirm/confirm.service';
import { RoutePartsService } from './services/route-parts.service';

import { FormlyModule } from '@ngx-formly/core';
import { FileUploadComponent } from '../form/components/file-upload/file-upload.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { RouterModule } from '@angular/router';
import { OrganizationGuard } from './guards/organization.guard';
import { LoginGuard } from './guards/login-guard.service';
import { SharedPipesModule } from './pipes/shared-pipes.module';
import { LogoutGuard } from './guards/logout.guard';
import { MetabaseStatsComponent } from './components/metabase-stats/metabase-stats.component';
import { SharedMaterialModule } from './shared-material.module';
import { SharedComponentsModule } from './components/shared-components.module';
import { OrganizationInitialGuard } from './guards/organization-initial.guard';
import { OrganizationListGuard } from './guards/organization-list.guard';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';
import { CycleHasIncentiveGuard } from './guards/cycle-hasIncentive.guard';
import { SharedDirectivesModule } from './directives/shared.directives.module';
import { RedirectLoginGuard } from './guards/redirect-login.guard';
import { MarTableComponent } from './components/table/mar-table.component';
import { BaseChartDirective } from 'ng2-charts';
import { OrganizationDetailGuard } from './guards/organization-detail.guard';


@NgModule({
  declarations: [
    MetabaseStatsComponent,
    FileUploadComponent
  ],
  imports: [
    BaseChartDirective,
    MarTableComponent,
    SharedDirectivesModule,
    SharedComponentsModule,
    SharedPipesModule,
    RouterModule,
    NgxFileDropModule,
    CommonModule,
    FormlyModule,
    SharedMaterialModule,
  ],
  providers: [
    OrganizationDetailGuard,
    RedirectLoginGuard,
    CycleHasIncentiveGuard,
    CanDeactivateGuard,
    OrganizationListGuard,
    OrganizationInitialGuard,
    LogoutGuard,
    RoutePartsService,
    AuthGuard,
    ConfirmService,
    LoginGuard,
    OrganizationGuard,
  ],
  exports: [
    BaseChartDirective,
    MarTableComponent,
    SharedDirectivesModule,
    SharedComponentsModule,
    MetabaseStatsComponent,
    SharedPipesModule,
    FileUploadComponent,
    FormlyModule,
  ],
})
export class SharedModule {
}
